import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../common/header";
import Sidebar from "../common/sidebar";
import Breadcrumb from "../common/menuGuide";
import { getTokenAsync } from "../../utils/tokenManage";
import alertUtils from "../../utils/utils";

function NoticeEditPage() {
    const navigate = useNavigate();
    const currentPath = window.location.pathname;

    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [serviceGroupList, setServiceGroupList] = useState([]);
    const [serviceGroup, setServiceGroup] = useState("");
    const [custCode, setCustCode] = useState("");

    const [repairInfo, setRepairInfo] = useState("");
    const [salesInfo, setSalesInfo] = useState("");
    const [etcInfo, setEtcInfo] = useState("");

    useEffect(() => {
        getServiceGroup();
    }, []);

    const getServiceGroup = async () => {
        try {
            const authToken = await getTokenAsync();

            const res = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/menu/oprmng?menuval=counselnotice&serviceType=S`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authToken
                    }
                }
            );

            if (!res.ok) {
                throw new Error("호텔 목록 조회 실패");
            }

            const data = await res.json();

            const filtered = data || [];

            setServiceGroupList(filtered);

            if (filtered.length > 0) {
                setServiceGroup(filtered[0].serviceGroup || "");
                setCustCode(filtered[0].custCode || "");
            }
        } catch (e) {
            console.error(e);
        }
    };

    const serviceGroupChange = (e) => {
        const selectedValue = e.target.value;
        const selectedItem = serviceGroupList.find(
            (item) => item.serviceGroup === selectedValue
        );

        setServiceGroup(selectedValue);
        setCustCode(selectedItem?.custCode || "");
    };

    const noticeEdit = async () => {
        if (
            !repairInfo.trim() &&
            !salesInfo.trim() &&
            !etcInfo.trim()
        ) {
            alertUtils.info("내용을 입력해 주세요.");
            return;
        }

        alertUtils.confirm("등록하시겠습니까?", async () => {
            try {
                const authToken = await getTokenAsync();

            const res = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/app/notice/edit`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authToken
                    },
                    body: JSON.stringify({
                        repairInfo,
                        salesInfo,
                        etcInfo,
                        custCode,
                        serviceGroup
                    })
                }
            );

                if (!res.ok) {
                    throw new Error("공지사항 저장 실패");
                }

                alertUtils.success("정상적으로 저장되었습니다.");
                navigate("/notice", {state: {refresh: true}});
            } catch (e) {
                console.error(e);
                alertUtils.error("저장 실패");
            }
        });
    };

    const editCancel = () => {
        alertUtils.confirm(
            "확인을 누르시면 작업한 내용은 저장되지 않습니다.\n공지사항 관리 화면으로 이동하시겠습니까?",
            () => {
                navigate("/notice", { state: { refresh: true } });
            }
        );
    };

    return (
        <div className="container">
            <Header onMenuToggle={() => setSidebarOpen((prev) => !prev)} />

            <Sidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                currentPath={currentPath}
            />

            <main className="content">
                <Breadcrumb items={["상담 관리", "공지사항관리", "공지사항 등록"]} />

                <section className="page">
                    <div className="resister-head">
                        <h1>공지사항 등록</h1>

                        <select
                            className="form-select"
                            aria-label="호텔 선택"
                            value={serviceGroup}
                            onChange={serviceGroupChange}
                            hidden={true}
                        >
                            {serviceGroupList.length === 0 ? (
                                <option value="">선택 가능한 호텔이 없습니다.</option>
                            ) : (
                                serviceGroupList.map((item) => (
                                    <option
                                        key={item.serviceGroup}
                                        value={item.serviceGroup}
                                    >
                                        {item.serviceGroupName}
                                    </option>
                                ))
                            )}
                        </select>

                        <div className="announcement-actions mt-4">
                            <div className="action-row">
                                <button
                                    type="button"
                                    className="btn btn-primary w-auto"
                                    onClick={noticeEdit}
                                >
                                    저장
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-gray w-auto"
                                    onClick={editCancel}
                                >
                                    취소
                                </button>
                            </div>
                        </div>
                    </div>

                    <table className="detail-table">
                        <tbody>

                        <tr>
                            <th>판매정보</th>
                            <td>
                                <textarea
                                    className="form-control h-150"
                                    placeholder="판매정보를 입력하세요."
                                    value={salesInfo}
                                    onChange={(e) => setSalesInfo(e.target.value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <th>수리 및 기타 정보</th>
                            <td>
                                <textarea
                                    className="form-control h-150"
                                    placeholder="수리 및 기타 정보를 입력하세요."
                                    value={repairInfo}
                                    onChange={(e) => setRepairInfo(e.target.value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <th>상담센터 기재 공지사항</th>
                            <td>
                                <textarea
                                    className="form-control h-150"
                                    placeholder="상담센터 기재 공지사항 내용을 입력하세요."
                                    value={etcInfo}
                                    onChange={(e) => setEtcInfo(e.target.value)}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
            </main>
        </div>
    );
}

export default NoticeEditPage;